<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoDetalhar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoDetalhar">
            <form>
                <div class="formgroup">
                    <div class="flex justify-content-center" *ngIf="exibirSpinnerPrincipal">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div *ngIf="messagemVisivel" class="w-auto mb-5">
                        <p-messages
                            [(value)]="messages"
                            [enableService]="false"
                            [closable]="true"
                        ></p-messages>
                    </div>
                    <div
                        class="p-fluid p-formgrid grid pt-3 px-3"
                        *ngIf="orcamento && !exibirSpinnerPrincipal"
                    >
                        <div class="col-12 card-simple mb-3">
                            <div class="p-fluid p-formgrid grid">
                                <div class="col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Nº da Proposta</label>
                                    <label class="label-inferior">
                                        {{ orcamento.numeroOrcamento }}
                                    </label>
                                </div>
                                <div class="col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Tipo</label>
                                    <label class="label-inferior">{{ orcamento.tipo }}</label>
                                </div>
                                <div class="col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Data da Proposta</label>
                                    <label class="label-inferior">
                                        {{ orcamento.dataOrcamento | date: "dd/MM/yyyy" }}
                                    </label>
                                </div>
                                <div class="col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Interessado</label>
                                    <label class="label-inferior">
                                        {{ orcamento.interessado?.nome }}
                                    </label>
                                </div>
                                <div class="col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Validade (Dias)</label>
                                    <label class="label-inferior">
                                        {{ orcamento.validadeProposta }}
                                    </label>
                                </div>
                                <div class="col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Valor da Proposta</label>
                                    <label class="label-inferior">
                                        {{ orcamento.valorProposta | currency: "BRL" }}
                                    </label>
                                </div>
                                <div class="col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Condição do Pagamento</label>
                                    <label class="label-inferior">
                                        {{ orcamento.condicaoPagamento }}
                                    </label>
                                </div>
                                <div class="col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Desconto</label>
                                    <label class="label-inferior">
                                        {{ orcamento.desconto?.toFixed(2) }}%
                                    </label>
                                </div>
                                <div
                                    class="col-12 md:col-6 xl:col-2"
                                    *ngIf="orcamento.status === 'PAGO'"
                                >
                                    <label class="label-superior">Valor Pago</label>
                                    <label class="label-inferior">
                                        {{ orcamento.valorPago | currency: "BRL" }}
                                    </label>
                                </div>
                                <div class="col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Status</label>
                                    <label class="label-inferior">
                                        <span
                                            class="product-badge bg-gray-600 admihair-text-white"
                                            *ngIf="orcamento.status === 'RESGATADO_CREDITO_CLIENTE'"
                                            pTooltip="Resgate com geração de crédito na conta do Cliente"
                                        >
                                            RESGATADO SALDO
                                        </span>
                                        <span
                                            *ngIf="orcamento.status === 'RESGATADO_PAGO'"
                                            class="product-badge bg-gray-600 admihair-text-white"
                                            pTooltip="Resgatado com pagamento ao Cliente"
                                        >
                                            RESGATADO PAGO
                                        </span>
                                        <span
                                            *ngIf="orcamento.status === 'PAGO'"
                                            class="product-badge bg-blue-600 admihair-text-white"
                                        >
                                            {{ orcamento.status }}
                                        </span>
                                        <span
                                            *ngIf="orcamento.status === 'FINALIZADO'"
                                            class="product-badge bg-green-600 admihair-text-white"
                                        >
                                            {{ orcamento.status }}
                                        </span>
                                        <span
                                            *ngIf="orcamento.status === 'ABERTO'"
                                            class="product-badge bg-teal-600 admihair-text-white"
                                        >
                                            {{ orcamento.status }}
                                        </span>
                                        <span
                                            *ngIf="orcamento.status === 'VENCIDO'"
                                            class="product-badge bg-red-600 admihair-text-white"
                                        >
                                            {{ orcamento.status }}
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-12">
                            <h5>Itens</h5>
                        </div>

                        <div class="w-full mb-5">
                            <p-table
                                #dt1
                                [value]="itensOrcamento"
                                dataKey="id"
                                [rows]="10"
                                [rowHover]="true"
                                styleClass="p-datatable-gridlines"
                                [paginator]="false"
                                responsiveLayout="scroll"
                                styleClass=" p-datatable-sm"
                            >
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Descrição</th>
                                        <th>Quantidade Proposta</th>
                                        <th *ngIf="orcamento.tipo === 'PACOTE'">
                                            Quantidade Entregue
                                        </th>
                                        <th *ngIf="orcamento.tipo === 'PACOTE'">Saldo</th>
                                        <th>Valor Unitário</th>
                                        <th>Desconto Item</th>
                                        <th>Valor Total</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>
                                            <label>{{ item.nomeItem }}</label>
                                        </td>
                                        <td>
                                            <label>{{ item.quantidadeProposta }}</label>
                                        </td>
                                        <td *ngIf="orcamento.tipo === 'PACOTE'">
                                            <label>{{ item.quantidadeEntregue }}</label>
                                        </td>
                                        <td *ngIf="orcamento.tipo === 'PACOTE'">
                                            <label>
                                                {{
                                                    item.quantidadeProposta -
                                                        item.quantidadeEntregue
                                                }}
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                {{ item.valorUnitario | currency: "BRL" }}
                                            </label>
                                        </td>
                                        <td>
                                            <label>{{ item.descontoItem.toFixed(2) }}%</label>
                                        </td>
                                        <td>
                                            <label>
                                                {{
                                                    item.quantidadeProposta * item.valorUnitario
                                                        | currency: "BRL"
                                                }}
                                            </label>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="summary">
                                    <div class="flex align-items-center justify-content-between">
                                        <div>
                                            Há
                                            {{ itensOrcamento ? itensOrcamento.length : 0 }} itens
                                            inseridos na Proposta.
                                        </div>
                                        <div>Total: {{ valorTotalItens | currency: "BRL" }}</div>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="7">Nenhum registro cadastrado.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>

                    <div
                        class="p-fluid p-formgrid grid justify-content-end"
                        *ngIf="!exibirSpinnerPrincipal"
                    >
                        <div class="field col-12 md:col-4 flex justify-content-end">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-outlined md:w-9rem"
                                routerLink="/apps/orcamentos-e-pacotes"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
